export default __webpack_public_path__ + "static/media/banner7.df03b355.jpeg";